import React from 'react'
import LuxPlusSingaporeAirlinesMastercardOfferBanner from './components/LuxPlusSingaporeAirlinesMastercardOfferBanner'
import LuxPlusSingaporeAirlinesMastercardTakeoverBackground from './components/LuxPlusSingaporeAirlinesMastercardTakeoverBackground'
import {
  LUX_PLUS_SIA_MASTERCARD_CAMPAIGN_ID,
  LUX_PLUS_SIA_MASTERCARD_TAKEOVER_ID,
} from './constants/luxPlusSingaporeAirlinesMastercardTakeoverConstants'

const luxPlusSingaporeAirlinesMastercardTakeoverConfig: App.SiteTakeoverConfig = {
  id: LUX_PLUS_SIA_MASTERCARD_TAKEOVER_ID,
  campaignTags: new Set([LUX_PLUS_SIA_MASTERCARD_CAMPAIGN_ID]),
  // Show on all verticals where LuxPlus+ and Flights are available
  verticals: new Set(['home', 'hotel', 'tours', 'cruise', 'flights']),
  offerTypes: new Set([
    'hotel',
    'cruise',
    'tour', // Tour V1
    'direct_tour', 'partner_tour', 'connection_tour', // Tour V2
    'experience',
  ]),
  backgroundElement: LuxPlusSingaporeAirlinesMastercardTakeoverBackground,
  palette: 'inverse',
  siteWide: {
    banner: {
      description: <LuxPlusSingaporeAirlinesMastercardOfferBanner withCta />,
      align: 'start',
      logo: undefined,
      hideOnOfferPagesForMobileScreenSize: true,
      showOnHomePage: true,
    },
  },
}

export default luxPlusSingaporeAirlinesMastercardTakeoverConfig
